<template>
  <div
    class="
      swiper-slide
      eco-carousel-item
      justify-content-start
      placeholder-glow
    "
  >
    <div class="eco-carousel-item--image placeholder bg-muted col-3"></div>
    <div class="p-4 col-10 d-flex flex-column justify-content-center">
      <h5 class="fw-bold placeholder placeholder-lg text-dark col-9"></h5>
      <h6 class="mb-2 text-muted placeholder col-4"></h6>
      <div class="placeholder placeholder-sm text-muted col-6 mt-1"></div>
      <div class="placeholder placeholder-sm text-muted col-6 mt-2"></div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.eco-carousel-item--image.placeholder {
  border-radius: 10px 0 0 10px;
}
.eco-carousel-item {
  cursor: wait !important;
  padding: 0;
  margin: 0 30px 0 0;
}
</style>